<template>
  <Loader :isVisible="isLoading" />
  <div class="top-wrapper">
    <div class="slideshow">
      <img v-rellax data-rellax-speed="-1.5" v-for="(image, index) in images" :key="index" :src="image"
        :class="{ 'slide': true, 'active': index === currentIndex }" alt="伊豆大島" @load="onImageLoad" />
    </div>
    <div class="kokozero-title-wrapper scroll-animation" v-scroll-animation :class="{ 'z-index-none': !isLoading }">
      <img src="@/assets/img/home/kokozero_syodou.png" alt="こころにゼロをとりもどせ" />
    </div>
    <div class="top-sub-wrapper scroll-animation" v-scroll-animation>
      <h2>伊豆大島 釣り合宿の記録</h2>
      <ul class="top-author-name-wrapper">
        <li class="top-author-name">佐藤那緒</li>
        <li class="top-author-name">髙瀬大輝</li>
        <li class="top-author-name">秀島杏典</li>
        <li class="top-author-name">森宙久</li>
      </ul>
    </div>
    <div class="top-description-wrapper">
      <p class="p-top-description">
        Let My Silent Heart Empty
        <span>&emsp; -&emsp;Record of Fishing Camp in Izu Oshima Island&emsp;-</span><br />
        “There should be a sense of worlds moving in unison or harmony.”
      </p>
    </div>
    <WhatsNew :limit="3" class="WhatsNew" />
  </div>
</template>

<script>
import Loader from "@/components/Loader.vue";
import axios from "axios";
import WhatsNew from "@/features/home/components/WhatsNew.vue";

export default {
  components: {
    Loader,
    WhatsNew,
  },
  name: "SlideShow",
  data() {
    return {
      isLoading: true,
      images: [], // 初期値は空
      currentIndex: 0,
      loadedImageCount: 0, // 読み込まれた画像の数
    };
  },
  computed: {
    currentImage() {
      return this.images[this.currentIndex];
    },
  },
  mounted() {
    this.addLoadAnimation(); // 読み込みアニメーションを追加
  },
  async mounted() {
    await this.loadImagesFromAPI(); // API から画像をロード
    this.startSlideshow(); // スライドショーを開始
  },
  methods: {
    // S3画像をAPI Gateway経由で取得
    async loadImagesFromAPI() {
      try {
        const apiUrl = process.env.VUE_APP_API_URL_FETCH_S3_IMAGES;
        const queryParams = { folder: "home/slideshow" };
        const queryString = new URLSearchParams(queryParams).toString();
        const url = `${apiUrl}?${queryString}`;

        const response = await axios.get(url);

        // bodyをJSON形式にパース
        const parsedBody = JSON.parse(response.data.body);

        // APIレスポンスから画像リストを設定
        if (parsedBody.images && parsedBody.images.length > 0) {
          this.images = parsedBody.images;
        } else {
          console.warn("Images array is empty.");
        }
      } catch (error) {
        console.error("Error loading images from API:", error);
      }
    },
    onImageLoad() {
      // 画像が読み込まれるたびにカウントを増やす
      this.loadedImageCount++;

      // すべての画像が読み込まれたらローダーを非表示
      if (this.loadedImageCount === this.images.length) {
        this.isLoading = false;
      }
    },
    startSlideshow() {
      setInterval(() => {
        this.currentIndex = (this.currentIndex + 1) % this.images.length;
      }, 5500);
    },
    addLoadAnimation() {//読み込み時にアニメーションを追加
      window.addEventListener("load", function () {
        // アニメーション対象の全要素を取得
        const elementsToAnimate = document.querySelectorAll(".js-load-animation");
        // 各要素にクラスを追加してアニメーションを開始
        elementsToAnimate.forEach((element) => {
          element.classList.add("loaded");
        });
      });
    },
  },
};
</script>

<style scoped>
.top-wrapper {
  position: relative;
  margin: 6%;
  margin-top: 2.8%;
  height: 1000px;
  width: auto;
}

.slideshow {
  position: absolute;
  top: 30px;
  height: 720px;
  width: 100%;
  z-index: 0;
}

.slide {
  position: absolute;
  width: 100%;
  height: 100%;
  opacity: 0;
  transition: opacity 1.5s ease-in-out;
  object-fit: cover;
  z-index: 1;
  object-position: 50% 80%;
}

.slide.active {
  opacity: 1;
}

.kokozero-title-wrapper {
  position: absolute;
  top: 38%;
  left: 50%;
  transform: translate(-50%, -50%);
  height: 300px;
  width: 300px;
  z-index: 103;
}

.kokozero-title-wrapper img {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  height: 230px;
  width: 230px;
  object-fit: contain;
}

.top-sub-wrapper {
  position: absolute;
  top: 23%;
  left: 0;
  height: auto;
  width: 100%;
  z-index: 3;
  writing-mode: vertical-lr;
  text-orientation: upright;
}

.top-sub-wrapper ul {
  list-style: none;
}

.top-sub-wrapper h2 {
  position: relative;
  top: 0;
  left: 18%;
  font-size: 23px;
  font-family: "ShipporiMinchoBold";
  color: transparent;
  /* テキストを透明にする */
  background: linear-gradient(225deg, #ffffff, #cbcbcb);
  /* グラデーションを設定 */
  background-clip: text;
  /* テキストに背景をクリップ */
  -webkit-background-clip: text;
}

.top-author-name-wrapper {
  position: absolute;
  top: 30%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 12px;
  padding: 10px;
  list-style: none;
  z-index: 99;
  right: 0;
  /* 右端に配置 */
  width: 33.33%;
  /* 画面幅の3分の1を指定 */
}

.top-author-name {
  font-size: 19px;
  font-family: "ShipporiMincho";
  color: transparent;
  background: linear-gradient(225deg, #ffffff, #cbcbcb);
  background-clip: text;
  -webkit-background-clip: text;
}

.js-load-animation {
  opacity: 0;
  transition: opacity 2s ease-in-out;
}

.js-load-animation.loaded {
  opacity: 1;
}

.top-description-wrapper {
  position: absolute;
  bottom: -30px;
  left: 0;
  height: auto;
  padding-bottom: 200px;
  width: 100%;
  background-color: #FFFFFF;
  z-index: 2;
  display: flex;
  align-items: flex-start;
}

.p-top-description {
  color: #5e5851;
  font-size: 12px;
  font-family: "copse";
  line-height: 1.6;
}

.p-top-description span {
  font-size: 11px;
}

.WhatsNew {
  position: absolute;
  bottom: 90px;
  right: 0;
  z-index: 3;
}

/* タブレット、スマートフォン向けのスタイル */
@media screen and (max-width: 1024px) {

  .top-wrapper {
    height: 850px;
  }

  .slideshow {
    height: 50vh;
    top: 85px
  }

  .kokozero-title-wrapper {
    top: 35%;
  }

  .kokozero-title-wrapper img {
    height: 130px;
    width: 130px;
  }

  .top-sub-wrapper {
    top: 23%;
  }

  .top-sub-wrapper h2 {
    font-size: 17px;
  }

  .top-author-name-wrapper {
    top: 28%;
    gap: 0px;
    padding: 10px;
  }

  .top-author-name {
    font-size: 15px;
  }

  .top-description-wrapper {
    bottom: 0px;
  }

  .p-top-description {
    font-size: 10px;
  }

  .p-top-description span {
    font-size: 10px;
  }

  .WhatsNew {
    bottom: 80px;
  }
}

@media screen and (max-width: 570px) {

  .top-wrapper {
    margin: 0%;
    height: 650px;
  }

  .slideshow {
    height: 45vh;
    top: 60px;
  }

  .slide {    
    object-position: 50% 90%;
  }

  .kokozero-title-wrapper {
    height: 130px;
    width: 130px;
}

  .kokozero-title-wrapper img {
    height: 100px;
    width: 100px;
  }

  .top-sub-wrapper {
    top: 23%;
  }

  .top-sub-wrapper h2 {
    font-size: 13px;
    top: 0%;
  }

  .top-author-name-wrapper {
    top: 27%;
    gap: 0px;
    padding: 5px;
  }

  .top-author-name {
    font-size: 10px;
  }

  .top-description-wrapper {
    padding-left: 4%;
    padding-top: 6px;
    width: 96%;
    height: 100px;
    bottom: -80px;
  }

  .p-top-description {
    font-size: 8px;
  }

  .p-top-description span {
    font-size: 8px;
  }

  .WhatsNew {
    bottom: 80px;
    right: 0;
  }
}
</style>